import {
  toggleParticipantListVisible,
  useAllParticipants,
} from '@cometchat/calls-sdk-core';
import React from 'react';
import Avatar from '../avatar/Avatar.web';
import './GroupAvatarTile.web.css';

export interface GroupAvatarTileProps {
  startIndex?: number;
  style?: React.CSSProperties;
}

const GroupAvatarTile: React.FC<GroupAvatarTileProps> = ({
  startIndex = 4,
  style,
}) => {
  const participants = useAllParticipants();

  const remainingParticipants = participants.slice(startIndex);
  const overflowCount = remainingParticipants.length;

  // Show max 3 avatars + 1 badge in 2x2 grid (4 positions total)
  const visibleAvatars = remainingParticipants.slice(
    0,
    Math.min(4, overflowCount > 4 ? 3 : 4),
  );
  const additionalCount = Math.max(0, overflowCount - 3);

  return (
    <div
      className="cometchat-calls-group-avatar-container"
      style={style}
      onClick={toggleParticipantListVisible}>
      {/* Show 2x2 grid with max 4 positions */}
      <div className="cometchat-calls-group-avatar-grid">
        {visibleAvatars.map(item => (
          <Avatar
            key={item.ruid}
            size={40}
            name={item.name}
            imageUrl={item.avatar}
          />
        ))}

        {/* Show + icon with remaining count if there are more than 4 total */}
        {overflowCount > 4 && (
          <div className="cometchat-calls-group-avatar-overflow-circle">
            <span className="cometchat-calls-group-avatar-overflow-text">
              {' '}
              +{additionalCount}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default GroupAvatarTile;
